import {
  FaAddressBook,
  FaServer,
  FaThLarge,
  FaBars,
  FaGraduationCap,
  FaUserGraduate,
  FaPaperPlane,
  FaClock,
  FaExclamationTriangle,
  FaTrashRestore,
  FaUserPlus,
  FaSignInAlt,
  FaLaptopCode,
  FaHeadset,
  FaLifeRing
} from "react-icons/fa";


const homeDropLink = [
  {
    id: 1,
    title: "SaaS Company 1",
    desc: "Its for Saas  Software Company1",
    link: "/saas1",
  },
  {
    id: 2,
    title: "SaaS Company 2",
    desc: "Modern Saas agency",
    link: "/saas2",
  },
  {
    id: 3,
    title: "Desktop App",
    desc: "Modern Web Company",
    link: "/saas3",
  },
  {
    id: 4,
    title: "App Landing",
    desc: "App and Software Landing",
    link: "/saas4",
  },
  {
    id: 5,
    title: "Sotware Applications",
    desc: "IT solutions and Saas Applications",
    link: "/saas5",
  },
  {
    id: 6,
    title: "Startup Agency",
    desc: "Differet Kinds of Startups",
    link: "/saas6",
  },
  {
    id: 7,
    title: "Data Analysis",
    desc: "Software and Data analysis",
    link: "/saas7",
  },
];


const homeDropSecondLink = [
  {
    id: 8,
    title: "App Landing 2",
    desc: "App and Software Landing",
    link: "/saas8",
  },
  {
    id: 9,
    title: "IT Solutions",
    desc: "IT solutions Saas Comapny",
    link: "/saas9",
  },
  {
    id: 10,
    title: "Cyber Security",
    desc: "Cyber Sycurity Landing Pages",
    link: "/saas10",
  },
  {
    id: 11,
    title: "Crypto Currency",
    desc: "Crypto Currency Landing Pages",
    link: "/saas11",
  },
  {
    id: 12,
    title: "Game Solutions",
    desc: "Game Server Landing Pages",
    link: "/saas12",
  },
  {
    id: 13,
    title: "Payment Gateway",
    desc: "Payment Gateway Landing Pages",
    link: "/saas13",
  },
];



const pagesDropDownLinks1 = [
  {
    id: 1,
    title: "Contact Us",
    desc: <FaAddressBook />,
    link: "/contact us",
  },
  {
    id: 2,
    title: "Services Single",
    desc: <FaServer />,
    link: "/Services Single",
  },
  {
    id: 3,
    title: "Our Latest News",
    desc: <FaThLarge />,
    link: "/Our Latest News",
  },
  {
    id: 4,
    title: "News Deatils",
    desc: <FaBars />,
    link: "/News Deatils",
  },
  {
    id: 5,
    title: "Careers",
    desc: <FaGraduationCap />,
    link: "/Careers",
  },
  {
    id: 6,
    title: "Career Single",
    desc: <FaUserGraduate />,
    link: "/Career Single",
  },
  {
    id: 7,
    title: "Integrations",
    desc: <FaPaperPlane />,
    link: "/Integrations",
  },
  {
    id: 8,
    title: "Integrations Single",
    desc: <FaClock />,
    link: "/Integrations Single",
  },
];  


const pagesDropDownLinks2 = [
  {
    id: 1,
    title: "Help Center",
    desc: <FaLifeRing />,
    link: "/Help Center",
  },
  {
    id: 2,
    title: "Help Details",
    desc: <FaHeadset />,
    link: "/Help Details",
  },
  {
    id: 3,
    title: "Request for Demo",
    desc: <FaLaptopCode />,
    link: "/Request for Demo",
  },
  {
    id: 4,
    title: "User Login",
    desc: <FaSignInAlt   />,
    link: "/User Login",
  },
  {
    id: 5,
    title: "User SignUp",
    desc: <FaUserPlus />,
    link: "/User SignUp",
  },
  {
    id: 6,
    title: "Recovery Account",
    desc: <FaTrashRestore />,
    link: "/Recovery Account",
  },
  {
    id: 7,
    title: "404 Page",
    desc: <FaHeadset />,
    link: "/404 Page",
  },
  {
    id: 8,
    title: "Comming Soon",
    desc: <FaExclamationTriangle />,
    link: "/Comming Soon",
  },
];

export {
  homeDropLink,
  homeDropSecondLink,
  pagesDropDownLinks1,
  pagesDropDownLinks2,
};
